export default {
  imageLayer: 'Klicken Sie auf einen Bild- Platzhalter um ein eigenes Bild hochzuladen oder Effekte anzuwenden.',
  textLayer: 'Klicken Sie auf den Text um ihn zu ändern. Im sich öffenden Menü können Sie außerdem Farbe und Schriftgröße anpassen.',
  tips: 'Falls Sie Bild- oder Textebenen löschen oder hinzufügen wollen, können Sie dies über »Layout« tun.',
};
